"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBlueprintEntity = void 0;
var irt_1 = require("@playq/irt");
var octopus_common_1 = require("@playq/octopus-common");
var BlueprintEntityData_1 = require("./BlueprintEntityData");
var BlueprintEntityBriefData_1 = require("./BlueprintEntityBriefData");
var services_flower_1 = require("@playq/services-flower");
var BlueprintEntityID_1 = require("./BlueprintEntityID");
var AppBlueprintEntity = (function () {
    function AppBlueprintEntity(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.tags = [];
            return;
        }
        this.name = data.name;
        this.desc = typeof data.desc !== 'undefined' ? data.desc : undefined;
        this.tags = data.tags.map(function (e) { return new octopus_common_1.Tag(e); });
        this.flowerId = data.flowerId;
        this.content = new services_flower_1.Blueprint(data.content);
        this.version = data.version;
        this.updatedAtAsString = data.updatedAt;
        this.createdBy = new octopus_common_1.UserID(data.createdBy);
        this.id = new BlueprintEntityID_1.BlueprintEntityID(data.id);
    }
    AppBlueprintEntity.prototype.getPackageName = function () { return AppBlueprintEntity.PackageName; };
    AppBlueprintEntity.prototype.getClassName = function () { return AppBlueprintEntity.ClassName; };
    AppBlueprintEntity.prototype.getFullClassName = function () { return AppBlueprintEntity.FullClassName; };
    Object.defineProperty(AppBlueprintEntity.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "desc", {
        get: function () {
            return this._desc;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._desc = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field desc expects type string, got ' + value);
            }
            this._desc = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "tags", {
        get: function () {
            return this._tags;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field tags is not optional');
            }
            this._tags = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "flowerId", {
        get: function () {
            return this._flowerId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field flowerId is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field flowerId expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field flowerId expects guid format, got ' + value);
            }
            this._flowerId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field content is not optional');
            }
            this._content = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "updatedAt", {
        get: function () {
            return this._updatedAt;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field updatedAt is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field updatedAt expects type Date, got ' + value);
            }
            this._updatedAt = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "updatedAtAsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._updatedAt);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('updatedAtAsString expects type string, got ' + value);
            }
            this._updatedAt = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "createdBy", {
        get: function () {
            return this._createdBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field createdBy is not optional');
            }
            this._createdBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppBlueprintEntity.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    AppBlueprintEntity.prototype.toBlueprintEntityDataSerialized = function () {
        return {
            name: this.name,
            desc: typeof this.desc !== 'undefined' ? this.desc : undefined,
            tags: this.tags.map(function (e) { return e.serialize(); }),
            flowerId: this.flowerId,
            content: this.content.serialize()
        };
    };
    AppBlueprintEntity.prototype.toBlueprintEntityData = function () {
        return new BlueprintEntityData_1.BlueprintEntityDataStruct(this.toBlueprintEntityDataSerialized());
    };
    AppBlueprintEntity.prototype.toBlueprintEntityBriefDataSerialized = function () {
        return {
            name: this.name,
            desc: typeof this.desc !== 'undefined' ? this.desc : undefined,
            tags: this.tags.map(function (e) { return e.serialize(); }),
            flowerId: this.flowerId
        };
    };
    AppBlueprintEntity.prototype.toBlueprintEntityBriefData = function () {
        return new BlueprintEntityBriefData_1.BlueprintEntityBriefDataStruct(this.toBlueprintEntityBriefDataSerialized());
    };
    AppBlueprintEntity.prototype.toEntityServerDataSerialized = function () {
        return {
            version: this.version,
            updatedAt: this.updatedAtAsString,
            createdBy: this.createdBy.serialize()
        };
    };
    AppBlueprintEntity.prototype.toEntityServerData = function () {
        return new octopus_common_1.EntityServerDataStruct(this.toEntityServerDataSerialized());
    };
    AppBlueprintEntity.prototype.loadBlueprintEntityDataSerialized = function (slice) {
        this.name = slice.name;
        this.desc = typeof slice.desc !== 'undefined' ? slice.desc : undefined;
        this.tags = slice.tags.map(function (e) { return new octopus_common_1.Tag(e); });
        this.flowerId = slice.flowerId;
        this.content = new services_flower_1.Blueprint(slice.content);
    };
    AppBlueprintEntity.prototype.loadBlueprintEntityData = function (slice) {
        this.loadBlueprintEntityDataSerialized(slice.serialize());
    };
    AppBlueprintEntity.prototype.loadBlueprintEntityBriefDataSerialized = function (slice) {
        this.name = slice.name;
        this.desc = typeof slice.desc !== 'undefined' ? slice.desc : undefined;
        this.tags = slice.tags.map(function (e) { return new octopus_common_1.Tag(e); });
        this.flowerId = slice.flowerId;
    };
    AppBlueprintEntity.prototype.loadBlueprintEntityBriefData = function (slice) {
        this.loadBlueprintEntityBriefDataSerialized(slice.serialize());
    };
    AppBlueprintEntity.prototype.loadEntityServerDataSerialized = function (slice) {
        this.version = slice.version;
        this.updatedAtAsString = slice.updatedAt;
        this.createdBy = new octopus_common_1.UserID(slice.createdBy);
    };
    AppBlueprintEntity.prototype.loadEntityServerData = function (slice) {
        this.loadEntityServerDataSerialized(slice.serialize());
    };
    AppBlueprintEntity.prototype.serialize = function () {
        return {
            name: this.name,
            desc: typeof this.desc !== 'undefined' ? this.desc : undefined,
            tags: this.tags.map(function (e) { return e.serialize(); }),
            flowerId: this.flowerId,
            content: this.content.serialize(),
            version: this.version,
            updatedAt: this.updatedAtAsString,
            createdBy: this.createdBy.serialize(),
            id: this.id.serialize()
        };
    };
    AppBlueprintEntity.PackageName = 'net.playq.octopus2.analytics';
    AppBlueprintEntity.ClassName = 'AppBlueprintEntity';
    AppBlueprintEntity.FullClassName = 'net.playq.octopus2.analytics.AppBlueprintEntity';
    return AppBlueprintEntity;
}());
exports.AppBlueprintEntity = AppBlueprintEntity;
BlueprintEntityData_1.BlueprintEntityDataStruct.register(AppBlueprintEntity.FullClassName, AppBlueprintEntity);
BlueprintEntityBriefData_1.BlueprintEntityBriefDataStruct.register(AppBlueprintEntity.FullClassName, AppBlueprintEntity);
octopus_common_1.EntityServerDataStruct.register(AppBlueprintEntity.FullClassName, AppBlueprintEntity);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(AppBlueprintEntity.FullClassName, {
    full: AppBlueprintEntity.FullClassName,
    short: AppBlueprintEntity.ClassName,
    package: AppBlueprintEntity.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new AppBlueprintEntity(); },
    fields: [
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'desc',
            accessName: 'desc',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'tags',
            accessName: 'tags',
            type: { intro: irt_2.IntrospectorTypes.List, value: { intro: irt_2.IntrospectorTypes.Data, full: 'net.playq.octopus.common.Tag' } }
        },
        {
            name: 'flowerId',
            accessName: 'flowerId',
            type: { intro: irt_2.IntrospectorTypes.Uid }
        },
        {
            name: 'content',
            accessName: 'content',
            type: { intro: irt_2.IntrospectorTypes.Data, full: 'net.playq.services.flower.Blueprint' }
        },
        {
            name: 'version',
            accessName: 'version',
            type: { intro: irt_2.IntrospectorTypes.U32 }
        },
        {
            name: 'updatedAt',
            accessName: 'updatedAt',
            type: { intro: irt_2.IntrospectorTypes.Tsz }
        },
        {
            name: 'createdBy',
            accessName: 'createdBy',
            type: { intro: irt_2.IntrospectorTypes.Id, full: 'net.playq.octopus.common.UserID' }
        },
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_2.IntrospectorTypes.Id, full: 'net.playq.octopus2.analytics.BlueprintEntityID' }
        }
    ]
});
//# sourceMappingURL=AppBlueprintEntity.js.map